import { Alert, Collapse, Link, alertClasses } from '@mui/material';
import { useState } from 'react';

import { AuthSessionStatus, api, useAuthContext, useAuthExpirationContext } from 'common';

export function AuthWarningBanner() {
  const { refreshLoginCheck } = useAuthContext();
  const { sessionStatus } = useAuthExpirationContext();
  const [authWarningState, setAuthWarningState] = useState<'pending' | 'visible' | 'dismissed'>(
    sessionStatus === AuthSessionStatus.Active ? 'pending' : 'visible'
  );
  return (
    <Collapse
      in={authWarningState !== 'dismissed' && sessionStatus !== AuthSessionStatus.Active}
      sx={{ width: '100%' }}
    >
      <Alert
        severity={sessionStatus === AuthSessionStatus.Expired ? 'error' : 'warning'}
        variant="standard"
        onClose={() => setAuthWarningState('dismissed')}
        sx={{
          paddingY: 0,
          borderRadius: 0,
          [`& .${alertClasses.icon}`]: {
            marginLeft: 'auto',
          },
          [`& .${alertClasses.message}`]: {
            fontWeight: 'bold',
          },
        }}
      >
        <span>
          {sessionStatus === AuthSessionStatus.Expired
            ? 'Your session has expired.'
            : 'Your session is about to expire.'}{' '}
          <Link
            component="button"
            onClick={async () => {
              await api.client.User.logout();
              refreshLoginCheck();
            }}
            sx={{
              paddingY: 0,
            }}
          >
            Reauthenticate
          </Link>
        </span>
      </Alert>
    </Collapse>
  );
}
